module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-pl-74076996b5835e0bcc3b4ab6dba6bd83.svg";